import React from 'react';
import './ThinkingOfJoining.css';
import { joiningSections } from '../data/thinkingOfJoiningSections';

interface ThinkingOfJoiningProps {
    onNavigate: (page: string) => void;
}

const ThinkingOfJoining: React.FC<ThinkingOfJoiningProps> = ({ onNavigate }) => {
    return (
        <section className="thinking-of-joining-section">
            <div className="container">
                <h1 className="page-title">Thinking of Joining?</h1>
                <p className="page-subtitle">
                    Find out everything you need to know about starting your Taekwon-Do journey with us
                </p>

                <div className="club-content">
                    {joiningSections.map((section) => (
                        <div key={section.id} id={section.id} className="content-section">
                            <h2>{section.title}</h2>
                            {typeof section.content === 'function' ? section.content(onNavigate) : section.content}
                            {section.id === 'trial-classes' && (
                                <button
                                    className="submit-button"
                                    style={{
                                        marginTop: '30px',
                                        padding: '16px 32px',
                                        fontSize: '1.1rem',
                                        fontWeight: 700,
                                        color: '#ffffff',
                                        background: '#dc3545',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px'
                                    }}
                                    onClick={() => onNavigate('trial-class')}
                                >
                                    Register for a Trial / Join here
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ThinkingOfJoining;
